import { createQueryPreloader } from '@apollo/client/react';
import { createApolloClient } from 'platform/apolloClient';

const client = createApolloClient({ batch: true });

export const preloadQuery = createQueryPreloader(client);
export const apolloClient = () => client;
